import React, { useState, useEffect, useContext, useRef } from 'react';
import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage.js";


let debounceTimer = null;

const AddItemPopup = ({ globalContext }) => {

    const [search, setSearch] = useState("");
    const [data, setData] = useState([]);
    const [hasMoreData, setHasMoreData] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoadingData, setIsLoadingData] = useState(false);
    const [alreadyAddedUniqueIds, setAlreadyAddedUniqueIds] = useState([]);
    const [isAddingUniqueIdsList, setIsAddingUniqueIdsList] = useState([]);

    const AppContext = globalContext;



    useEffect(() => {

        // Load the list of already added ids to not allow duplicates when adding

        let enumId = 1; // 0: Regulations, 1: Standards

        let dataUrl = "/umbraco/api/Compliance/Ids/";

        let loadIdsURL = dataUrl + `?` +
            `type=${encodeURIComponent(enumId)}&`;

        if (globalContext.currentLegalManufacturerFilter)
            loadIdsURL += "legalManufacturerId=" + globalContext.currentLegalManufacturerFilter + "&";

        let requestOptions = {};

        fetch(loadIdsURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    setHasMoreData(false);
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {
                setAlreadyAddedUniqueIds(result);
            })
            .catch((error) => {
            })
            .finally(() => {
            });

    }, []);





    const doTextSearchTask = (textSearch) => {
        let debouncingTime = 500;
        clearTimeout(debounceTimer);

        debounceTimer = setTimeout(() => {
            loadSearchResults({ localSearch: textSearch, nextPage: false });
        }, debouncingTime);
    };


    const loadSearchResults = ({
        localSearch = search,
        nextPage = false,
    } = {}) => {

        if (isLoadingData) return;

        setIsLoadingData(true);

        let local_data = data;
        let local_data_page = currentPage;

        if (nextPage == false) {
            local_data = [];
            local_data_page = 1;
            setData(local_data);
            setCurrentPage(local_data_page);
            setHasMoreData(true);
        } else {
            local_data_page++;
            setCurrentPage(local_data_page);
        }


        let dataUrl = AppContext.dataUrl+"Search";

        let loadDataURL = dataUrl + `?` +
            `search=${encodeURIComponent(localSearch)}&` +
            `page=${encodeURIComponent(local_data_page)}&` +
            `sortBy=&` +
            `sortType=&`
            ;


        if (globalContext.currentLegalManufacturerFilter)
            loadDataURL += "legalManufacturerId=" + globalContext.currentLegalManufacturerFilter + "&";


        let requestOptions = {};

        fetch(loadDataURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    setHasMoreData(false);
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                // If no items returned it means there is no more data to retrieve
                if (result.length == 0)
                    setHasMoreData(false);
                else {
                    // Was it a fetch more request? Then append to data.
                    if (nextPage) {
                        let res = [...local_data, ...result];
                        setData(res);
                    } else {
                        setData(result);
                    }

                }

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                setHasMoreData(false);
            })
            .finally(() => {
                setIsLoadingData(false);
            });


    };



    const addStandard = (UniqueId) => {


        let item = data.filter((item) => item.UniqueId == UniqueId);

        if (item.length) {

            item = item[0];

            let newItem = {
                Id: 0,
                UniqueId: item.UniqueId,
                Name: item.Name,
                Type: item.Type,
                Stage: item.Stage,
                Compliance_Status: null,
                Open_Tasks: 0,
                LegalManufacturerId: globalContext.currentLegalManufacturerFilter == -1 ? null : parseInt(globalContext.currentLegalManufacturerFilter)
            };


            let dataUrl = AppContext.dataUrl;
            
            let requestOptions = {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(newItem)
            };

            setIsAddingUniqueIdsList([...isAddingUniqueIdsList, UniqueId]);

            fetch(dataUrl, requestOptions)
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401)
                            document.dispatchEvent(new Event("api:unauthorized"));
                        throw new Error("Network response was not ok");
                    }
                    return response.json();
                })
                .then((item) => {

                    let result = [item, ...AppContext.data];

                    AppContext.setData(result);

                    setAlreadyAddedUniqueIds([...alreadyAddedUniqueIds, item.UniqueId]);

                })
                .catch((error) => {
                    // Handle any errors that occurred during the fetch
                    console.log("error: " + error);
                })
                .finally(() => {
                    // Remove item from list of loading
                    setIsAddingUniqueIdsList([...isAddingUniqueIdsList.filter((item) => item != UniqueId)]);
                });

            

            


        }

    }





    const targetRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsVisible(entry.isIntersecting);
            },
            { threshold: 0 } // Adjust the threshold as needed
        );

        if (targetRef.current) {
            observer.observe(targetRef.current);
        }

        return () => {
            if (targetRef.current) {
                observer.unobserve(targetRef.current);
            }
        };
    }, [isLoadingData]);


    useEffect(() => {

        if (isVisible && hasMoreData && !isLoadingData) {
            loadSearchResults({ nextPage: true });
        }
    }, [isVisible]);





    return (
        <div className="add-task-popup">
            <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ width: "50%" }}>
                    <h3>Add {AppContext.singleItemTitle}</h3>
                </div>
                <div style={{ width: "50%", textAlign: "right" }}>
                    <button
                        className="close-button"
                        onClick={() => AppContext.showAddItemPopup(false)}
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>
            </div>
            <input
                value={search}
                className={`form-field-text`}
                onChange={(e) => { setSearch(e.target.value); doTextSearchTask(e.target.value); }}
                style={{ width: "100%" }}
                type="text"
                placeholder="Search Standards"
            />
            {AppContext.errorAddItemName && (
                <span className="form-field-error-message">
                    This field is necessary
                </span>
            )}
            <br />
            <br />

            {/* RESULTS LIST */}

            {(data.length > 0 || search != "") &&
                <>
                    <div style={{ width: "100%", display: "flex", flexDirection: "row", borderBottom: "1px solid #f0f0f0", fontWeight: "bold" }}>
                        <div style={{ width: "50%" }}>NAME</div>
                        <div style={{ width: "15%" }}>TYPE</div>
                        <div style={{ width: "15%" }}>STAGE</div>
                        <div style={{ width: "10%" }}>YEAR</div>
                        <div style={{ width: "10%" }}>ACTIONS</div>
                    </div>

                    <div className="thin-scrollbar" style={{ width: "100%", maxHeight: "450px", overflowY: "auto", display: "flex", flexDirection: "column" }}>

                        {data.map((item, index) => {

                            return (
                                <div key={index} className="results-table-row" style={{ width: "100%", display: "flex", padding: "6px 0px", flexDirection: "row", borderBottom: "1px solid #f0f0f0", }}>
                                    <div style={{ width: "50%" }}>{item.Name}</div>
                                    <div style={{ width: "15%" }}>{item.Type}</div>
                                    <div style={{ width: "15%" }}>{item.Stage}</div>
                                    <div style={{ width: "10%" }}>{item.Year}</div>
                                    <div style={{ width: "10%" }}>


                                        {isAddingUniqueIdsList.find((loading) => loading == item.UniqueId) ? <>

                                            <LoadingSpinnerImage />

                                        </> : <>

                                            {alreadyAddedUniqueIds.find((i) => i == item.UniqueId) ? <>
                                                <span style={{
                                                    padding: "3px 7px",
                                                    border: "1px solid #999",
                                                    borderRadius: "5px",
                                                    backgroundColor: "#c0c0c0"
                                                }}>Added</span>
                                            </> : <>
                                                <span style={{
                                                    cursor: "pointer",
                                                    padding: "3px 7px",
                                                    border: "1px solid #999",
                                                    borderRadius: "5px",
                                                    backgroundColor: "#cbeeff"
                                                }} onClick={() => addStandard(item.UniqueId)}>Add</span>
                                            </>}

                                        </>}

                                    </div>
                                </div>

                            );
                        })}

                        {/* Loading and no-more-results row */}

                        <div style={{ marginBottom: "20px" }}>

                            {isLoadingData ?
                                <div style={{ textAlign: "center", }}>
                                    <LoadingSpinnerImage />
                                </div>
                                :
                                <>
                                    {/* If this div is visible it should try to load more data. Either inner div content or minHeight is mandatory for the intersector to work */}
                                    <div ref={targetRef} style={{ minHeight: "5px" }}></div>
                                </>
                            }

                            {!hasMoreData && (
                                <div className="no-more-results">No more results</div>
                            )}

                        </div>


                    </div>
                </>


            }

            {/* BUTTONS */}

            <div className="action-button-bar">
                <div className="action-button-bar-left"></div>
                <div className="action-button-bar-center">
                    <button
                        className="action-button cancel-button"
                        onClick={() => AppContext.showAddItemPopup(false)}
                    >
                        Close
                    </button>
                </div>
                <div className="action-button-bar-right"></div>
            </div>




        </div>
    );
};


export default AddItemPopup;